/**
 * Copyright 2020 Opstrace, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react";

const TracyImg = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52.14 71.16"
    >
      <defs>
        <style>{`.cls-1{fill:#f54773;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-2,.cls-3{fill:#091570;}.cls-4{fill:#fff;}.cls-5{fill:#e6e6e6;}.cls-6{fill:#d42d57;}`}</style>
      </defs>
      <title>Tracy</title>
      <path
        className="cls-1"
        d="M639.23,527.32s.22,0,.7,0l.4,15.18a4.33,4.33,0,0,0,8.65-.23l-.4-15.23h0l0-1a20.88,20.88,0,0,0,2.28-.88,85.14,85.14,0,0,1,.39,12.6,4.34,4.34,0,0,0,8.63.92c.93-8.72-2.43-16,.67-23.34a38,38,0,0,0,3.2-14.62,20.32,20.32,0,0,0-2.24-9.27c-4.22-8.32-13.26-13-22.41-13s-18.19,4.68-22.42,13a20.31,20.31,0,0,0-2.23,9.27,37.8,37.8,0,0,0,3.2,14.62c3.09,7.36-.26,14.62.67,23.34a4.34,4.34,0,0,0,8.63-.92,83.89,83.89,0,0,1,.39-12.61c.76.34,1.52.63,2.27.88l0,1.06h0l-.41,15.23a4.33,4.33,0,0,0,8.66.23l.4-15.18c.65,0,1,0,1,0Z"
        transform="translate(-613 -477)"
      />
      <path
        className="cls-2"
        d="M639.23,527.32Zm0,0,.7,0,.4,15.18a4.33,4.33,0,0,0,8.65-.23L648.55,526a20.88,20.88,0,0,0,2.28-.88,85.14,85.14,0,0,1,.39,12.6,4.34,4.34,0,0,0,8.63.92c.93-8.72-2.43-16,.67-23.34a38,38,0,0,0,3.2-14.62,20.32,20.32,0,0,0-2.24-9.27c-4.22-8.32-13.26-13-22.41-13s-18.19,4.68-22.42,13a20.31,20.31,0,0,0-2.23,9.27,37.8,37.8,0,0,0,3.2,14.62c3.09,7.36-.26,14.62.67,23.34a4.34,4.34,0,0,0,8.63-.92,83.89,83.89,0,0,1,.39-12.61c.76.34,1.52.63,2.27.88l-.43,16.3a4.33,4.33,0,0,0,8.66.23l.4-15.18c.61,0,1,0,1,0Zm1.47,19.26a5.79,5.79,0,0,1-1.63-2.85,5.74,5.74,0,0,1-5.6,4.42h-.14a5.73,5.73,0,0,1-5.59-5.75v-.1h0l0-1.61a5.75,5.75,0,0,1-4.45,3.21l-.22,0a5.74,5.74,0,0,1-6.21-5,1.52,1.52,0,0,1,0-.21,49.75,49.75,0,0,1,.28-10.22c.45-4.44.86-8.6-.84-12.63a44.55,44.55,0,0,1-2.47-7.7,34.7,34.7,0,0,1-.84-7.47,22,22,0,0,1,2.39-9.91,24.45,24.45,0,0,1,9.62-10,28.3,28.3,0,0,1,28.12,0,24.45,24.45,0,0,1,9.62,10,22,22,0,0,1,2.39,9.91,34.7,34.7,0,0,1-.84,7.47,44,44,0,0,1-2.48,7.7c-1.69,4-1.28,8.19-.84,12.63a47.93,47.93,0,0,1,.27,10.31,5.75,5.75,0,0,1-10.19,3,5.82,5.82,0,0,1-.71-1.11l0,1.45a.86.86,0,0,1,0,.16h0a5.75,5.75,0,0,1-5.45,5.85h-.18a5.71,5.71,0,0,1-4.07-1.57Z"
        transform="translate(-613 -477)"
      />
      <path
        className="cls-3"
        d="M634.85,514.66h8.44a.77.77,0,0,1,.78.77A5,5,0,0,1,642.6,519h0a5,5,0,0,1-7.06,0h0a5,5,0,0,1-1.47-3.53.77.77,0,0,1,.78-.77Z"
        transform="translate(-613 -477)"
      />
      <path
        className="cls-4"
        d="M639.07,512.58a13.34,13.34,0,1,0-13.34-13.34,13.38,13.38,0,0,0,13.34,13.34Z"
        transform="translate(-613 -477)"
      />
      <path
        className="cls-2"
        d="M639.07,504.41a5.17,5.17,0,1,0-5.17-5.17,5.18,5.18,0,0,0,5.17,5.17ZM638,500.7a2.47,2.47,0,1,0-2.47-2.47A2.48,2.48,0,0,0,638,500.7Z"
        transform="translate(-613 -477)"
      />
      <path
        className="cls-5"
        d="M646.63,488.26a13.33,13.33,0,0,0-20.9,11,13.37,13.37,0,0,0,9.63,12.81,13.34,13.34,0,0,1,11.27-23.79Z"
        transform="translate(-613 -477)"
      />
      <path
        className="cls-6"
        d="M651.6,481.51a26.89,26.89,0,0,0-12.53-3.09c-9.16,0-18.19,4.68-22.42,13a20.31,20.31,0,0,0-2.23,9.27,37.8,37.8,0,0,0,3.2,14.62c3.09,7.36-.26,14.62.67,23.34a4.33,4.33,0,0,0,4.77,3.85h0a4.33,4.33,0,0,1-.84-2.15c-.93-8.72,2.42-16-.68-23.34a38,38,0,0,1-3.19-14.61,20.35,20.35,0,0,1,2.23-9.28c4.22-8.32,13.26-13,22.42-13a27,27,0,0,1,8.56,1.39Z"
        transform="translate(-613 -477)"
      />
      <path
        className="cls-3"
        d="M639.07,511.87a12.65,12.65,0,1,0-8.93-3.71,12.6,12.6,0,0,0,8.93,3.71Zm9.92-2.7a14,14,0,1,1,4.13-9.93,14,14,0,0,1-4.13,9.93Z"
        transform="translate(-613 -477)"
      />
      <path
        className="cls-6"
        d="M639.07,518.88a3.41,3.41,0,0,0,1.53-.36,5.94,5.94,0,0,0-1.57-2.31h-3.32a3.54,3.54,0,0,0,.92,1.66,3.47,3.47,0,0,0,2.44,1Z"
        transform="translate(-613 -477)"
      />
    </svg>
  );
};

export default TracyImg;
